export default "__VITE_ASSET__daf605d9__"